// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ProviderResponse } from './provider-response';

/** See com.rev360.pms.api.controller.patient.referral.ReferralProviderResponse */
/* istanbul ignore next */
@GandalfModel
export class ReferralProviderResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	credential!: string | null;

	@GandalfProperty({ designType: String })
	directAddress!: string | null;

	@GandalfProperty({ designType: ProviderResponse })
	provider!: ProviderResponse;

}
